<div class="channels_list_container">
    <ng-container *msLoadingSpinner="isChannelsLoading$ | async; color: 'secondary'">
        @if (!(channelsListIsEmpty$ | async)) {
            <div class="sb_box_container">
                <div class="sb_list_container">
                    <ul class="channels_list">
                        @for (category of channelsCategories; track category; let categoryIndex = $index) {
                            @if (category.channels.length > 0 || category.collections.length > 0) {
                                <li
                                    class="category"
                                    [attr.category-id]="category.id"
                                    [attr.category-type]="category.type"
                                >
                                    <div class="category_name">
                                        <span class="name">{{ category.name }}</span>
                                        @if (category.name != 'Uncategorized') {
                                            <span class="edit_category">
                                                @if (showEditCategory && adminOrSuperAdmin) {
                                                    <a
                                                        data-testid="edit-category-button"
                                                        (click)="toggleEditCategoryModal(category)"
                                                    >
                                                        <mat-icon>
                                                            <i class="fas fa-pen"></i>
                                                        </mat-icon>
                                                    </a>
                                                }
                                            </span>
                                        }
                                    </div>
                                    <ul class="category_channelsList categoryCollectionList">
                                        @for (
                                            collection of category.collections;
                                            track collection;
                                            let itemIndex = $index
                                        ) {
                                            <li [attr.channelFolder-id]="collection.id" class="channel_group">
                                                @if (collection.id != null) {
                                                    <div>
                                                        <mat-expansion-panel
                                                            [expanded]="isExpandedFolders[collection.id]"
                                                            [hideToggle]="true"
                                                            (opened)="onCollapseFolder(collection.id, true)"
                                                            (closed)="onCollapseFolder(collection.id, false)"
                                                        >
                                                            <mat-expansion-panel-header>
                                                                <div class="collection-wrapper">
                                                                    <a
                                                                        class="group_title"
                                                                        [attr.data-target]="collection.id"
                                                                        [class.unread]="
                                                                            showReadAndUnreadPosts &&
                                                                            collection.has_unread
                                                                        "
                                                                    >
                                                                        <div class="collection-name-wrapper">
                                                                            <span class="collection_name">{{
                                                                                collection.name
                                                                            }}</span>
                                                                            @if (isExpandedFolders[collection.id]) {
                                                                                <mat-icon>
                                                                                    <i class="fal fa-angle-up"></i>
                                                                                </mat-icon>
                                                                            }
                                                                            @if (!isExpandedFolders[collection.id]) {
                                                                                <mat-icon
                                                                                    ><i class="fal fa-angle-down"></i
                                                                                ></mat-icon>
                                                                            }
                                                                        </div>
                                                                        <div class="edit-collection">
                                                                            <button
                                                                                mat-icon-button
                                                                                data-testid="collection-menu-button"
                                                                                [matMenuTriggerFor]="collectionMenu"
                                                                                (click)="$event.stopPropagation()"
                                                                                class="more-menu"
                                                                            >
                                                                                <mat-icon class="size-auto"
                                                                                    ><i class="far fa-ellipsis-v"></i
                                                                                ></mat-icon>
                                                                            </button>

                                                                            <mat-menu #collectionMenu="matMenu">
                                                                                <div class="menu-wrapper">
                                                                                    @if (
                                                                                        showEditCollection &&
                                                                                        (hasAdminRights ||
                                                                                            canAccessSuperadminSection)
                                                                                    ) {
                                                                                        <button
                                                                                            mat-menu-item
                                                                                            class="dropdown-item add_channel"
                                                                                            data-testid="collection-menu-edit-button"
                                                                                            (click)="
                                                                                                toggleEditCollectionModal(
                                                                                                    collection.id
                                                                                                )
                                                                                            "
                                                                                        >
                                                                                            Edit collection
                                                                                        </button>
                                                                                    }
                                                                                    <button
                                                                                        mat-menu-item
                                                                                        class="dropdown-item add_collection"
                                                                                        data-testid="collection-menu-unsubscribe-button"
                                                                                        (click)="
                                                                                            unsubscribeCollection(
                                                                                                collection.id
                                                                                            )
                                                                                        "
                                                                                    >
                                                                                        Unsubscribe from collection
                                                                                    </button>
                                                                                </div>
                                                                            </mat-menu>
                                                                        </div>
                                                                        @if (
                                                                            showReadAndUnreadPosts &&
                                                                            (collection.has_unread ||
                                                                                (unreadStatusLoading | async))
                                                                        ) {
                                                                            <span
                                                                                [ngClass]="{
                                                                                    'has-admin-rights':
                                                                                        !adminOrSuperAdmin,
                                                                                    loading:
                                                                                        unreadStatusLoading | async,
                                                                                }"
                                                                                [attr.class]="
                                                                                    'risk-score-' + collection.score
                                                                                "
                                                                                class="unread_num"
                                                                            >
                                                                                <mat-icon class="size-auto"
                                                                                    ><i
                                                                                        class="fas fa-exclamation-triangle"
                                                                                    ></i
                                                                                ></mat-icon>
                                                                            </span>
                                                                        }
                                                                    </a>
                                                                </div>
                                                            </mat-expansion-panel-header>
                                                            <ul [id]="collection.id">
                                                                @for (
                                                                    channel of collection.channels;
                                                                    track channel;
                                                                    let itemIndex = $index
                                                                ) {
                                                                    <ng-template
                                                                        *ngTemplateOutlet="
                                                                            tplChannel;
                                                                            context: { $implicit: channel }
                                                                        "
                                                                    ></ng-template>
                                                                }
                                                            </ul>
                                                        </mat-expansion-panel>
                                                    </div>
                                                }
                                            </li>
                                        }
                                        @for (channel of category.channels; track channel; let itemIndex = $index) {
                                            <ng-template
                                                *ngTemplateOutlet="tplChannel; context: { $implicit: channel }"
                                            ></ng-template>
                                        }
                                    </ul>
                                </li>
                            }
                        }
                    </ul>
                </div>
            </div>
        }
    </ng-container>

    @if (channelsListIsEmpty$ | async) {
        <div class="emptyChannels">No available channels</div>
    }
</div>

<ng-template #tplChannel let-channel>
    <li
        [attr.channel-id]="channel.id"
        [attr.channel-type]="channel.type"
        [ngClass]="{
            'has-crawl-errors': channel.has_crawl_errors,
            unread: showReadAndUnreadPosts && channel.has_unread,
        }"
        class="channel_item"
        matTooltip="Some searches have been stopped in this channel"
        [matTooltipDisabled]="!channel.has_crawl_errors"
    >
        <a [routerLink]="['../app/channel', channel.id]" routerLinkActive="active"
            ><span class="channel_name">{{
                channel.name.length > 25 ? (channel.name | slice: 0 : 25) + '..' : channel.name
            }}</span>

            <button
                mat-icon-button
                [matMenuTriggerFor]="chMenu"
                data-testid="channel-menu-button"
                class="more-menu"
                (click)="$event.preventDefault(); $event.stopPropagation()"
            >
                <mat-icon class="size-auto"><i class="far fa-ellipsis-v"></i></mat-icon>
            </button>

            @if (showReadAndUnreadPosts && (channel.has_unread || (unreadStatusLoading | async))) {
                <span
                    [ngClass]="{
                        'has-admin-rights': !adminOrSuperAdmin,
                        loading: unreadStatusLoading | async,
                    }"
                    [attr.class]="'risk-score-' + channel.score"
                    class="unread_num"
                >
                    <mat-icon class="size-auto"><i class="fas fa-exclamation-triangle"></i></mat-icon>
                </span>
            }
        </a>

        <mat-menu #chMenu="matMenu">
            <div class="menu-wrapper">
                @if (showEditChannel && adminOrSuperAdmin) {
                    <button
                        mat-menu-item
                        class="dropdown-item add_channel"
                        data-testid="channel-menu-form-button"
                        (click)="toggleChannelFormModal(channel.id)"
                    >
                        Edit channel
                    </button>
                }
                @if (adminOrSuperAdmin) {
                    <button
                        mat-menu-item
                        class="dropdown-item add_collection"
                        data-testid="channel-menu-export-button"
                        (click)="toggleExportChannelModal(channel.id)"
                    >
                        Export channel
                    </button>
                }
                <button
                    mat-menu-item
                    class="dropdown-item add_collection"
                    data-testid="channel-menu-unsubscribe-button"
                    (click)="unsubscribeChannel(channel.id)"
                >
                    Unsubscribe from channel
                </button>
                @if (adminOrSuperAdmin) {
                    <button
                        mat-menu-item
                        class="dropdown-item add_collection"
                        data-testid="channel-menu-delete-button"
                        (click)="toggleDeleteChannel(channel.id)"
                    >
                        Delete channel
                    </button>
                }
            </div>
        </mat-menu>
    </li>
</ng-template>
